var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186 163.4",
    style: {
      enableBackground: "new 0 0 186 163.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186,86.3l-88.5,77.1l-11.7-14.2c28.3-23.4,58.8-45.8,79.3-59.6l-0.6-1.6c-23.7,1.6-61,2.4-92.3,2.4H0V72.7h72.2 c31.3,0,68.6,1.1,92.3,2.7l0.6-1.6c-21-14.4-50.7-36.5-79.2-59.9L97.8,0L186,76.8V86.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f2e4bb0c3cbc8cc6ce199132b334c57a.svg";
export { ForwardRef as ReactComponent };